import {
  useFeatureFlag,
  useFeatureFlagsLoaded,
} from "@src/features/app/hooks/useFeatureFlag";
import useActionPermissions from "@src/features/app/hooks/useActionPermissions";
import useIsFullAdmin from "@src/features/app/hooks/useIsFullAdmin";
import useUser from "@src/features/app/hooks/useUser";
import { useOrgFeatureFlagsQuery } from "@src/features/app/top-nav/SetOrgFeatureFlags.generated";
import { Ff } from "@src/types.generated";

export type CommsOptInAccess = {
  canOptIn: boolean;
  loading: boolean;
};

const useCanOptIntoComms = (): CommsOptInAccess => {
  const flagsLoaded = useFeatureFlagsLoaded();
  const commsOptInFlag = useFeatureFlag(Ff.CommsOptIn);
  const { user } = useUser();
  const isFullAdmin = useIsFullAdmin();
  const { userActionPermissions, loading: permissionsLoading } =
    useActionPermissions();
  const { data: orgFlagsData, loading: orgFlagsLoading } =
    useOrgFeatureFlagsQuery({ skip: !commsOptInFlag || !isFullAdmin });

  const orgHasNewMessaging = !!orgFlagsData?.OrgFeatureFlags.find(
    (flag) => flag.name === Ff.NewMessaging,
  )?.enabled;
  const loading =
    !flagsLoaded ||
    !user?.userType ||
    (commsOptInFlag && isFullAdmin && (permissionsLoading || orgFlagsLoading));
  const canOptIn =
    !loading &&
    commsOptInFlag &&
    isFullAdmin &&
    !!userActionPermissions?.changeOrgSettings &&
    !!orgFlagsData &&
    !orgHasNewMessaging;
  return { canOptIn, loading };
};

export default useCanOptIntoComms;
